import { getLookupQuery } from 'src/app/helpers/url.helper';
import { loggerApiSlice } from 'src/app/redux/api/loggerApiSlice';
import { LogLookupDataType, LogLookupResultType } from 'src/app/redux/logs/logs-slice.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const logSlice = loggerApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLogs: builder.query<LogLookupResultType, LogLookupDataType | void>({
      query: (params?: LogLookupDataType) => ({
        url: finalUrlsConfig().logs.lookup,
        params: getLookupQuery(params),
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.rows.map(({ id }) => ({
                type: 'Logs' as const,
                id,
              })),
              { type: 'Logs', id: 'LIST' },
            ]
          : [{ type: 'Logs', id: 'LIST' }],
    }),
    getLogsInfinite: builder.query<LogLookupResultType, LogLookupDataType | void>({
      query: (params?: LogLookupDataType) => ({
        url: finalUrlsConfig().logs.lookup,
        params: getLookupQuery(params),
      }),
      serializeQueryArgs: ({ endpointName }) => endpointName,
      merge: (currentCache, newItems, { arg }) => {
        if (currentCache.rows.length !== currentCache.count) {
          currentCache.rows.push(...newItems.rows);
          currentCache.count = newItems.count;
        }

        if (arg && arg.offset === 0) {
          currentCache.rows = [];
          currentCache.rows.push(...newItems.rows);
          currentCache.count = newItems.count;
        }
      },
      // forceRefetch({ currentArg, previousArg }) {
      //   return currentArg?.offset !== previousArg?.offset;
      // },
      providesTags: (result) =>
        result
          ? [
              ...result.rows.map(({ id }) => ({
                type: 'Logs' as const,
                id,
              })),
              { type: 'Logs', id: 'LIST' },
            ]
          : [{ type: 'Logs', id: 'LIST' }],
    }),
  }),
});

export const { useGetLogsInfiniteQuery, useGetLogsQuery } = logSlice;
